// orderApi.js
import { http } from './httpClient';
const PAGE_SIZE = 10;

export function getOrderProducts({
                                     customerId, branchId, search = '', page = 0, size = PAGE_SIZE,
                                     webCategoryId, webSubCategoryId, signal
                                 }) {
    return http.get('/api/public/order-products', {
        customerId, branchId, search, page, size, webCategoryId, webSubCategoryId,
    }, { signal });
}

// ✅ Har qanday http klient uchun body ni normalizatsiya qilib qaytaramiz
export async function submitOrder(dto, { signal } = {}) {
    const res = await http.post('/api/public/submit-order', dto, {
        signal,
        headers: { 'Content-Type': 'application/json' }, // xavfsiz
    });

    // axios -> res.data; fetch-wrapper -> res.body yoki to‘g‘ridan res bo‘lishi mumkin
    const body =
        (res && typeof res === 'object' && ('success' in res || 'data' in res || 'message' in res)) ? res :
            (res && res.data)  ? res.data  :
                (res && res.body)  ? res.body  :
                    res;

    return body; // <-- HECH QACHON undefined qaytarmasin
}
